import axios from "axios"

const getDetailsTvshow = async (tmdbId, callbackError) => {
    try {
        const response = await axios.request({
            method: 'GET',
            url: `${process.env.REACT_APP_THEMOVIEDB_HOST}/tv/${tmdbId}`,
            params: {
                api_key: process.env.REACT_APP_THEMOVIEDB_API
            }
        });
        return response.data
    } catch (error) {
        callbackError(error);
    }
}

export {
    getDetailsTvshow
}
